import { Link } from "react-router-dom";
import { Home, AlertTriangle } from "lucide-react";
import Navbar from "@/components/Navbar";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <Navbar />
      <main className="min-h-[calc(100vh-80px)] flex flex-col items-center justify-center px-6 text-center">
        <AlertTriangle className="w-14 h-14 text-blue-400 mb-6" strokeWidth={1.5} />
        <h1 className="text-6xl font-bold mb-3">404</h1>
        <p className="text-white/60 mb-8 max-w-md">
          Cette page n'existe pas ou a été déplacée.
        </p>
        <Link
          to="/"
          className="flex items-center gap-2 rounded-xl bg-blue-600 hover:bg-blue-500 transition-colors px-5 py-3 text-sm font-medium"
        >
          <Home className="w-4 h-4" />
          Retour à l'accueil
        </Link>
      </main>
    </div>
  );
}
